import React from "react";
import styles from "./Style.module.css";
import DashboardSnackbar from "../../../components/Snackbar.component";
import classNames from "classnames";
import logoImage from "../../../assets/CRMAssets/login_logo@2x.png";
import { IconButton, ButtonBase, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import useLoginHook from "./Login.hook";
import CustomTextField from "../../../components/FormFields/TextField/TextField.component";
import { useTheme } from "@mui/styles";
import CaptchaComponent from "../component/CaptchaComponent";
import GoogleCaptchaComponent from "../component/GoogleCaptcha.component";
import constants from "../../../config/constants";
import { ArrowPrimaryButton } from "../../../components/Buttons/PrimaryButton";

function LoginView() {
  const theme = useTheme();
  const {
    handleSubmit,
    onBlurHandler,
    changeTextData,
    form,
    errorData,
    togglePasswordVisibility,
    showPassword,
    captchaRef,
    isSubmitting,
    authState,
  } = useLoginHook();

  return (
    <div className={"login"}>
      <div className={styles.overlay}></div>
      <div className={styles.mainLoginView}></div>
      <div className={styles.container}>
        <div className={styles.loginFlex2}>
          <div className={styles.logoImageData}>
            <img src={logoImage} alt="text_data" style={{ width: "150px" }} />
          </div>
          <div className={styles.signContainer}>
            <div className={styles.loginHeaderText}>
              <Typography variant="h3">Welcome to Tyvenza Assist</Typography>

              <Typography
                variant={"body1"}
                sx={{ color: theme?.palette?.text?.secondary }}
              >
                Enter the details below to login to your account
              </Typography>
            </div>

            <div className={styles.formContainer}>
              <div className={styles.formFlexGrouup}>
                <div className={"formGroup"}>
                  <CustomTextField
                    isError={errorData?.email}
                    errorText={errorData?.email}
                    label={
                      <>
                        Email ID
                        <span style={{ color: theme.palette.error.main }}>
                          *
                        </span>
                      </>
                    }
                    value={form?.email}
                    onTextChange={(text) => {
                      changeTextData(text, "email");
                    }}
                    onBlur={() => {
                      onBlurHandler("email");
                    }}
                  />
                </div>
              </div>
              <div className={styles.formFlexGrouup}>
                <div className={"formGroup"}>
                  <div style={{ display: "flex", marginTop: "8px" }}>
                    <CustomTextField
                      type={showPassword ? "text" : "password"}
                      isError={errorData?.password}
                      errorText={errorData?.password}
                      label={
                        <>
                          Password
                          <span style={{ color: theme.palette.error.main }}>
                            *
                          </span>
                        </>
                      }
                      value={form?.password}
                      onTextChange={(text) => {
                        changeTextData(text, "password");
                      }}
                      onBlur={() => {
                        onBlurHandler("password");
                      }}
                    />

                    <IconButton
                      className={styles.visibleIcon}
                      onClick={togglePasswordVisibility}
                    >
                      {!showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                    <Link to="/forgot-password" style={{ textDecoration: 'none' }}>
                      <Typography
                        variant="body2"
                        style={{ cursor: "pointer", color: theme?.palette?.primary?.main || '#2063ce', fontWeight: 'bold' }}
                      >
                        Forgot Password?
                      </Typography>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.logFlex}>
              <div className={classNames(styles.negativeSpacing, "log")}>
                {/* <CaptchaComponent  handleSubmit={handleSubmit} ref={captchaRef}/> */}
                <GoogleCaptchaComponent
                  ref={captchaRef}
                  siteKey={constants.GOOGLE_CAPTCHA_KEY}
                  isVisible={!authState?.is_authenticated}
                />
                <div className={styles.loginAction}>
                  <ArrowPrimaryButton
                    variant={"h6"}
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    isVisible={!authState?.is_authenticated}
                  >
                    LOGIN
                  </ArrowPrimaryButton>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DashboardSnackbar />
      </div>
    </div>
  );
}

export default LoginView;
